import type { TourStep } from '../types';

export const designCreateSteps: TourStep[] = [
  {
    target: '[data-tour="design-modal"]',
    title: 'Создание дизайн-макета',
    content: 'Форма создания нового дизайна. Загрузите файл макета и заполните метаданные для правильной каталогизации.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-form-theme-number"]',
    title: 'Номер темы',
    content: 'Уникальный номер темы дизайна. Используется для группировки связанных макетов. Формат: числовой код.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-form-type"]',
    title: 'Тип дизайна',
    content: 'Тип макета: иллюстрация, фото, паттерн, шрифтовой и др. Влияет на отображение и фильтрацию.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-form-category"]',
    title: 'Категория',
    content: 'Категория дизайна для фильтрации: праздники, природа, абстракция, персонажи и т.д.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-form-brand-ru"]',
    title: 'Бренд (RU)',
    content: 'Название бренда на русском языке. Отображается в карточках товаров на российских маркетплейсах.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-form-brand-en"]',
    title: 'Бренд (EN)',
    content: 'Название бренда на английском языке. Используется для международных маркетплейсов и документации.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-form-gender"]',
    title: 'Пол',
    content: 'Целевая аудитория по полу: мужской, женский, унисекс. Влияет на размещение в категориях маркетплейсов.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-form-age"]',
    title: 'Возраст',
    content: 'Целевая возрастная группа: детский, подростковый, взрослый. Используется для фильтрации и маркетинга.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-form-seasonal"]',
    title: 'Сезонность',
    content: 'Отметьте, если дизайн сезонный (Новый год, 8 марта, лето и т.д.). Влияет на планирование ассортимента.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-form-theme"]',
    title: 'Тема',
    content: 'Тематика дизайна: природа, животные, праздники, абстракция. Помогает в поиске и группировке.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-form-emotion"]',
    title: 'Эмоция',
    content: 'Эмоциональный посыл дизайна: весёлый, романтичный, строгий. Используется для маркетинговых целей.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="design-form-submit"]',
    title: 'Создание',
    content: 'После заполнения формы нажмите "Создать". Дизайн появится в каталоге и будет готов к привязке к товарам.',
    placement: 'top',
    disableBeacon: true,
  },
];
